import React from "react";
import SidebarProvider from "./Context/SidebarContext";
import LeftNav from "./Navigation/LeftNav";
import Navbar from "./Navigation/Navbar";
import { useSidebar } from "./Context/SidebarContext";
import { Outlet } from "react-router-dom";
import Backdrop from "./Navigation/BackDrop";

const LayoutContent = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();

  return (
    <div className="min-h-screen xl:flex">
      <div>
        <LeftNav />
        <Backdrop />
      </div>
      <div
        className={`flex-1 transition-all duration-300 ease-in-out ${
          isExpanded || isHovered ? "lg:ml-[290px]" : "lg:ml-[90px]"
        } ${isMobileOpen ? "ml-0" : ""}`}
      >
        <Navbar />
        <div className="p-4 mx-auto max-w-(--breakpoint-2xl) md:p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

function DashboardLayout() {
  return (
      <SidebarProvider>
        <LayoutContent />
      </SidebarProvider>
  );
}

export default DashboardLayout;
